import React, { ChangeEvent } from 'react';
import Checkbox from '@mui/material/Checkbox';

import { CreditInvoice, CreditInvoiceFile } from '@types';
import { FileControlled } from '@components';
import { SentBy } from '@pages/credit/SentBy';
import cls from './credit-invoice-note.module.css';
import { dateFormatter } from '@utils';
import { cxHttp } from '@network';

interface CreditInvoiceNoteProps {
  invoice: CreditInvoice;
  creditCode: string;
  file: CreditInvoiceFile;
  date: string | null;
  comment: string;
  updateValues: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const CreditInvoiceNote = ({
  invoice, creditCode, file, comment, updateValues,
}: CreditInvoiceNoteProps) => {
  const ext = file.isPdf ? 'pdf' : 'jpg';
  const downloadFilename = `Invoice#${invoice.id}_${creditCode}.${ext}`;
  const updatedDate = invoice?.createdAt
    ? dateFormatter.toDateTime(invoice.createdAt, true) : '';

  const countInvoices = (invoice.invoices || []).length;

  const downloadCreditInvoices = countInvoices > 0 ? async (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    await cxHttp.downloadCreditInvoices(invoice.id, creditCode);
  } : undefined;

  return (
    <>
      <div className={cls.note}>
        <div className={cls.noteDate}>
          Update {updatedDate}
        </div>
        <div className={cls.noteExtracted}>
          <span>Extracted from XML</span>
          <Checkbox
            checked={invoice.isXml}
            size="large"
            disabled
            style={{ transform: 'scale(1.5)', marginTop: -5 }}
          />
        </div>
        <textarea
          name="comment"
          onChange={updateValues}
          className={cls.noteInput}
          placeholder="Comments"
          value={comment}
        />
      </div>
      <div className={cls.file}>
        <div className={cls.sendBy}>
          <SentBy
            type={invoice.managerId ? 'manager' : invoice.adminId ? 'admin' : 'user'}
          />
        </div>
        {countInvoices > 0 && (
          <div className={cls.filesCount}>{countInvoices + 1} files</div>
        )}
        <FileControlled
          adminUrl={file.adminUrl}
          downloadFilename={downloadFilename}
          downloadAction={downloadCreditInvoices}
        />
      </div>
    </>
  );
};
